import { httpClientVendasCoreBff } from 'vendas-core/shared/services'

import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

export type Affiliation = {
  id?: string
  merchantId?: string
  gateway?: string
  status?: string
  affiliationCode?: string
  paymentMethod?: string
  isStaging?: boolean
  isDebitEnabled?: boolean
  isCreditCardVerifyEnabled?: boolean
  brands?: string[]
}

export type AffiliationListResponse = {
  data?: Affiliation[]
}

export const GET_AFFILIATIONS_QUERY_KEY = 'useGetAffiliations'

async function getAffiliations(paymentProfileId: string): Promise<AffiliationListResponse> {
  const { data } = await httpClientVendasCoreBff<AffiliationListResponse>({
    url: `/v1/payment-profile/${paymentProfileId}/affiliations`,
    method: 'GET'
  })
  return data
}

export function useGetAffiliations(
  paymentProfileId?: string,
  options?: UseQueryRequestOptions<AffiliationListResponse, unknown, true> & { enabled?: boolean }
) {
  return useQueryRequest<AffiliationListResponse, unknown, true>(
    [GET_AFFILIATIONS_QUERY_KEY, paymentProfileId] as const,
    () => getAffiliations(paymentProfileId!),
    {
      enabled: Boolean(paymentProfileId) && (options?.enabled ?? true),
      ...options
    }
  )
}
